module.exports = __webpack_public_path__ + "static/img/card6-8.37095f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card6-8.png
// module id = a2Yx
// module chunks = 1